function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LoginTemplate = require('./login.template');
var SaitoOverlay = require('./../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoLoader = require('./../../../lib/saito/ui/saito-loader/saito-loader');
var LoginSuccessTemplate = require('./login-success.template');
var LoginSelectionTemplate = require('./login-selection.template');
var SaitoUser = require('./../../../lib/saito/ui/saito-user/saito-user');
var Login = /*#__PURE__*/function () {
  function Login(app, mod) {
    var _this = this;
    _classCallCheck(this, Login);
    this.app = app;
    this.mod = mod;
    this.modal_overlay = new SaitoOverlay(this.app, this.mod);
    this.loader = new SaitoLoader(this.app, this.mod, '#login-template');
    app.connection.on('recovery-login-overlay-render-request', function () {
      console.debug('Received recovery-login-overlay-render-request');
      _this.render();
    });
  }
  return _createClass(Login, [{
    key: "render",
    value: function render() {
      this.modal_overlay.show(LoginTemplate());
      this.attachEvents();
    }
  }, {
    key: "show",
    value: function show() {
      this.render();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.remove();
    }
  }, {
    key: "remove",
    value: function remove() {
      this.modal_overlay.remove();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      document.querySelector('.saito-overlay-login-submit').onclick = function (e) {
        var email = document.querySelector('.saito-overlay-form-email').value;
        var password = document.querySelector('.saito-overlay-form-password').value;
        document.querySelector('.saito-overlay-form-email').remove();
        document.querySelector('.saito-overlay-form-password').remove();
        document.querySelector('.saito-button-row').remove();
        _this2.loader.render();
        document.querySelector('#login-template .saito-overlay-form-text').innerHTML = '<center>Fetching Encrypted Wallet from Network...</center>';
        _this2.mod.restoreWallet(email, password);
      };
      var openPrivateKey = function openPrivateKey() {
        _this2.hide();
        _this2.mod.key_entry.render('key');
      };
      var openSeedPhrase = function openSeedPhrase() {
        _this2.hide();
        _this2.mod.key_entry.render('phrase');
      };
      var privateKeyLink = document.getElementById('restore-private-key');
      if (privateKeyLink) {
        privateKeyLink.onclick = openPrivateKey;
        privateKeyLink.onkeydown = function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openPrivateKey();
          }
        };
      }
      var seedPhraseLink = document.getElementById('restore-seed-phrase');
      if (seedPhraseLink) {
        seedPhraseLink.onclick = openSeedPhrase;
        seedPhraseLink.onkeydown = function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openSeedPhrase();
          }
        };
      }
    }
  }, {
    key: "success",
    value: function () {
      var _success = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(publicKey) {
        var user;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this.app.BROWSER) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.modal_overlay.closebox = false;
              this.modal_overlay.show(LoginSuccessTemplate());

              //constructor(app, mod, container = '', publicKey = '', notice = '', fourthelem = '') {
              user = new SaitoUser(this.app, this.mod, '.saito-user-field', publicKey, publicKey);
              user.render();
              document.querySelector('.saito-overlay-login-submit').onclick = function (e) {
                reloadWindow(300);
              };
              this.modal_overlay.blockClose();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function success(_x) {
        return _success.apply(this, arguments);
      }
      return success;
    }()
  }, {
    key: "failure",
    value: function failure() {
      try {
        this.render();
        document.querySelector('#login-template .saito-overlay-form-text').innerHTML = '<center>Failed: Incorrect Email or Password?</center>';
        this.attachEvents();
      } catch (err) {
        console.error(err);
      }
    }
  }, {
    key: "installWallet",
    value: function () {
      var _installWallet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var show_success,
          result,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              show_success = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
              _context2.n = 1;
              return this.app.wallet.onUpgrade('import', '', row.decrypted_wallet);
            case 1:
              result = _context2.v;
              if (result) {
                this.success(row.publickey);
              } else {
                console.error(result);
                this.failure();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function installWallet(_x2) {
        return _installWallet.apply(this, arguments);
      }
      return installWallet;
    }()
  }, {
    key: "selection",
    value: function () {
      var _selection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(rows) {
        var _this3 = this;
        var _iterator, _step, r, user;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (rows.length == 1) {
                this.installWallet(rows[0]);
              } else {
                this.modal_overlay.closebox = false;
                this.modal_overlay.show(LoginSelectionTemplate());
                _iterator = _createForOfIteratorHelper(rows);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    r = _step.value;
                    user = new SaitoUser(this.app, this.mod, '.recovery-wallet-selection', r.publickey, r.publickey);
                    user.data_disable = true;
                    user.render();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                Array.from(document.querySelectorAll('.recovery-wallet-selection .saito-user')).forEach(function (elem) {
                  elem.onclick = function (e) {
                    var pkey = e.currentTarget.dataset.id;
                    console.log(pkey);
                    var _iterator2 = _createForOfIteratorHelper(rows),
                      _step2;
                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        var r = _step2.value;
                        if (r.publickey == pkey) {
                          _this3.installWallet(r);
                        }
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  };
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function selection(_x3) {
        return _selection.apply(this, arguments);
      }
      return selection;
    }()
  }]);
}();
module.exports = Login;